<script lang="ts">
  import { Table } from "sveltestrap";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import InvoicePayment from "./InvoicePayment.svelte";
  import InvoiceTableBody from "./InvoiceTableBody.svelte";
</script>
<div>
  <div class="table-responsive invoice-table" id="table">
    <Table striped bordered>
      <tbody>
        <tr>  
          {#each data.invoicedata as invoiceItem }
            <td class={invoiceItem.class}>
              <h6 class="p-2 mb-0">{invoiceItem.title}</h6>
            </td>
          {/each}
        </tr>
        <InvoiceTableBody />
      </tbody>
    </Table>
  </div>
  <InvoicePayment />
</div>